import { TenantEntity } from '../TenantEntity'

export class FbaPartitionSetting extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaPartitionSetting'
  }

  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber
  }
  get partitionName() {
    return this._data.partitionName
  }
  set partitionName(partitionName) {
    this._data.partitionName = partitionName
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get referenceTiming() {
    return this._data.referenceTiming
  }
  set referenceTiming(referenceTiming) {
    this._data.referenceTiming = referenceTiming || 0
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }
}
